import { EventColorMap, ColorsToRoute } from './providers/enums';
import { FlagColorData } from './mapsData';
import { endpoints } from 'Core/defaultValues';
import { ColorsToRoutePointsOnRoutesTracker, TypeLayer } from '../Map/providers/enums'

import { getApiDate } from '../../core/hooks/useUnitData';
import { LogManagerConsole } from '../../core/logManager';
import moment from 'moment';

/*******************************************************
* Get the color value from the markers
*******************************************************/
export const getEventColor = (event) => {
  if(!event){
    return '#d7d7d6'
  }
  const eventColor = EventColorMap.find((item) => item.eventName == event)
  return eventColor?.color || '#d7d7d6'
}

/*******************************************************
* Return the route color depends of the speed of the route
* the speedValue is in Miles
*******************************************************/
export const getRouteColorFromSpeed = (speedValue) => {
    let valueColor = ColorsToRoute.find((item) => item.range >= speedValue)
    if(speedValue >= 75) valueColor = { color : "#ff7701" }
    return valueColor || { color : "#cacfd2" }
}

/*******************************************************
* Return the folder at the markers files
*******************************************************/
export const changePathMarker = (event) => {
  if(!event){
    return 'gray'
  }
  const eventColor = EventColorMap.find((item) => item.eventName == event)
  return eventColor?.folder || 'gray'
}

/***********************************************************************************
* Return the name image related to the angle (bearing - degress)
***********************************************************************************/
 export const changeMarker = (deg, pathRoute) => {
  const defaultName = 'ico_caret_40x40_';
  const path = `${pathRoute}${defaultName}`;
  if ((deg > 348 && deg <= 360) || (deg >= 0 && deg < 11)) {
      return path + "N.png";
  }

  if (deg >= 11 && deg < 33) {
      return path + "NNE.png";
  }

  if (deg >= 33 && deg < 56) {
      return path + "NE.png";
  }

  if (deg >= 56 && deg < 78) {
      return path + "ENE.png";
  }

  if (deg >= 78 && deg < 101) {
      return path + "E.png";
  }

  if (deg >= 101 && deg < 123) {
      return path + "ESE.png";
  }

  if (deg >= 123 && deg < 146) {
      return path + "SE.png";
  }

  if (deg >= 146 && deg < 168) {
      return path + "SSE.png";
  }

  if (deg >= 168 && deg < 191) {
      return path + "S.png";
  }

  if (deg >= 191 && deg < 213) {
      return path + "SSW.png";
  }

  if (deg >= 213 && deg < 236) {
      return path + "SW.png";
  }

  if (deg >= 236 && deg < 258) {
      return path + "WSW.png";
  }

  if (deg >= 258 && deg < 281) {
      return path + "W.png";
  }

  if (deg >= 281 && deg < 303) {
      return path + "WNW.png";
  }

  if (deg >= 303 && deg < 326) {
      return path + "NW.png";
  }

  if (deg >= 326 && deg <= 348) {
      return path + "NNW.png";
  }

  return path + "N.png";
}

/*******************************************************
* check to ensure that the two line segments are in
counter clock wise direction
*******************************************************/
export const _CCW = (p1, p2, p3) => {
  let a = p1.lng, b = p1.lat
  let c = p2.lng, d = p2.lat;
  let e = p3.lng, f = p3.lat;
  return (f - b) * (c - a) > (d - b) * (e - a);
}

/*******************************************************
* check to see if the two line segments intersect
*******************************************************/
export const _isIntersect = (p1, p2, p3, p4) => {
  return (_CCW(p1, p3, p4) != _CCW(p2, p3, p4)) && (_CCW(p1, p2, p3) != _CCW(p1, p2, p4));
}

/*******************************************************
* This function checks a polygon for line intersection.
* (uses rotational directions to check for intersection)
*
* @param array points - an array of google Markers representing the vertices of the polygon
* @returns {boolean}
*******************************************************/
export const validateLineIntersection = (points) => {
  if (points && points.length > 3) {

      // collect the points of the polygon
      var latlngs = [];
      latlngs = points

      // push the first point to the end of the array to close the polygon
      latlngs.push(points[0]);

      /**
       * Iterate through each lines and check to make sure that all line AFTER the next line does not intersect it.
       * The reason why we're always skipping the next line segment is because the next line will always intersect
       * the current line, since they connect with each other. This same reason is why we also ignore the case where
       * the last line intersects the first line.
       **/
      for(var i = 0; i < latlngs.length-1; i++) {

          // the start and end points of the line segment
          var p1 = latlngs[i],
              p2 = latlngs[i+1]
          ;

          // iterate through all the lines AFTER the next line (hence the +2)
          for(var j = i+2; j < latlngs.length-1; j++) {

              // ignore the case where the first line connects with the last line
              if ((i == 0) && (j == (latlngs.length-2))) {
                  continue;
              }

              // the start and end points of the line segment to compare
              var p3 = latlngs[j],
                  p4 = latlngs[j+1]
              ;

              // check to see if the two lines intersect
              if (_isIntersect(p1, p2, p3, p4)) {
                  return false;
              }
          }

          // the polygon passed the line intersection validation
          if (i == latlngs.length-2) {
              return true;
          }
      }
  } else {
      return true;
  }
}


/*******************************************************
* This function checks a polygon to see if its center point is inside of itself.
* (uses ray-casting algorithm)
*
* @param array points - an array of google Markers representing the vertices of the polygon
* @returns {boolean}
*******************************************************/
export const validateCenter = (points) => {
  if (points && points.length > 3) {
      var latlngs = convertArray(points)
      var center = getCentroid(latlngs)

      return _inside([center[0], center[1]], latlngs);

  } else {
      return true;
  }
}

/*******************************************************
* Convert to array
*
* @param coordinates - array to coordinates
* @returns array [lat, lng]
*******************************************************/
export const convertArray = (coordinates) => {
  var latlngs = Array()
  Object.keys(coordinates).map((keyLandmark) => {
      const itemPos = coordinates[keyLandmark]
      latlngs.push([itemPos.lat, itemPos.lng])
  })
  return latlngs
}

/*******************************************************
* Convert to array
*
* @param coordinates - array to coordinates
* @returns array [lat, lng]
*******************************************************/
export const convertArrayOther = (coordinates, latName, lngName ) => {
  var latlngs = Array()
  Object.keys(coordinates).map((keyItems) => {
      const itemPos = coordinates[keyItems]
      let lat = parseFloat(itemPos[latName]).toFixed(5)
      let lng = parseFloat(itemPos[lngName]).toFixed(5)
      latlngs.push([lat, lng])
  })
  return latlngs
}


/*******************************************************
* Use ray casting algorithm to make sure that the center is inside the polygon
*
* ray-casting algorithm based on
* http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html
* MIT license
*
* @param point - the center point
* @param vs    - vertices of the polygon
* @returns {boolean}
*******************************************************/
export const _inside = (point, vs) => {
  var x = point[0], y = point[1];
  var inside = false;
  for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
      var xi = vs[i][0],
          yi = vs[i][1],
          xj = vs[j][0],
          yj = vs[j][1]
          ;

      var intersect = ((yi > y) != (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);

      if (intersect) {
          inside = !inside; // w00t iswydt
      }
  }
  return inside;
}

/*******************************************************
 * Find the center element basic
*******************************************************/
export const getCentroidBasic = function (arr) {
  return arr.reduce(function (x,y) {
      return [x[0] + y[0]/arr.length, x[1] + y[1]/arr.length]
  }, [0,0])
}

/*******************************************************
* Get the center to the polygon
*
* @param arr - points the polygon, float data
* @returns center[[lat, lng], [lat, lng], [lat, lng]]
*******************************************************/
export const getCentroid = (arr) => {
  var twoTimesSignedArea = 0;
  var cxTimes6SignedArea = 0;
  var cyTimes6SignedArea = 0;

  var length = arr.length

  var x = function (i) { return arr[i % length][0] };
  var y = function (i) { return arr[i % length][1] };

  for ( var i = 0; i < arr.length; i++) {
      var twoSA = x(i)*y(i+1) - x(i+1)*y(i);
      twoTimesSignedArea += twoSA;
      cxTimes6SignedArea += (x(i) + x(i+1)) * twoSA;
      cyTimes6SignedArea += (y(i) + y(i+1)) * twoSA;
  }
  var sixSignedArea = 3 * twoTimesSignedArea;
  return [ cxTimes6SignedArea / sixSignedArea, cyTimes6SignedArea / sixSignedArea];
}

/*******************************************************
 * validate intersect to create polygon
 * @param array points = [{lat: -12.92352245954124, lng: -38.41864362359048}]
 *******************************************************/
 export const validatePolygon = (points) => {

  let response =  { status: true, message: '' }
  // first, check to make sure that no lines intersect
  if (validateLineIntersection(points)) {
      // second, check to make sure that the center is inside the polygon
      if (validateCenter(points)) {
          return response;
      } else {
          response = { status: false, message: 'The center point has to be inside the polygon.'}
          return response;
      }
  } else {
      response = { status: false, message: 'Polygon edges cannot intersect.'}
  }
  return response;
}

export const landmarkSvg = (color = '#FC10E8') => {
    return `<svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>ico_landmark</title>
        <defs>
            <polygon id="path-1" points="16.4816667 5.33333333 15.9483333 2.66666667 3.94833333 2.66666667 3.94833333 25.3333333 6.615 25.3333333 6.615 16 14.0816667 16 14.615 18.6666667 23.9483333 18.6666667 23.9483333 5.33333333"></polygon>
        </defs>
        <g id="ico_landmark" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
            </mask>
            <use id="flag" fill="${color}" fill-rule="nonzero" xlink:href="#path-1"></use>
        </g>
    </svg>`
}

/* --------------------------------------------------
-- Find the correct color or similar to the flag icon
---------------------------------------------------*/
export const findColor = (colorToSearch) => {
    if (!colorToSearch) return FlagColorData[0];

    if (colorToSearch?.length < 6) { //format color to 6 char elements #000000
        let countValues = 6 - colorToSearch.length;
        colorToSearch = colorToSearch + '0'.repeat(countValues);
    }

    const itemColor = FlagColorData.find((item) => item.toUpperCase() == colorToSearch.toUpperCase());
    let responseColor = '';
    if (itemColor) {
        responseColor = itemColor.toUpperCase();
    } else {
        responseColor = findSimilarColor(FlagColorData, colorToSearch.toUpperCase());
    }
    return responseColor;
}

/* --------------------------------------------------
-- Compare de colors and return the similar element
---------------------------------------------------*/
const findSimilarColor = (colors, colorToSearch) => {
    let responseColor = '';
    let findColor = -1;
    colors.forEach((color) => {
        let valueC = hexColorDelta(color.toUpperCase(), colorToSearch.toUpperCase())
        if (valueC > findColor) {
            findColor = valueC;
            responseColor = color.toUpperCase();
        }
    })
    return responseColor || '0000FF' //default icon - blue;
}

/* --------------------------------------------------
-- algorithm that identifies a similar color, return html color
---------------------------------------------------*/
const hexColorDelta = (hex1, hex2) => {
    // get red/green/blue int values of hex1
    var r1 = parseInt(hex1.substring(0, 2), 16);
    var g1 = parseInt(hex1.substring(2, 4), 16);
    var b1 = parseInt(hex1.substring(4, 6), 16);
    // get red/green/blue int values of hex2
    var r2 = parseInt(hex2.substring(0, 2), 16);
    var g2 = parseInt(hex2.substring(2, 4), 16);
    var b2 = parseInt(hex2.substring(4, 6), 16);
    // calculate differences between reds, greens and blues
    var r = 255 - Math.abs(r1 - r2);
    var g = 255 - Math.abs(g1 - g2);
    var b = 255 - Math.abs(b1 - b2);
    // limit differences between 0 and 1
    r /= 255;
    g /= 255;
    b /= 255;
    // 0 means opposit colors, 1 means same colors
    return (r + g + b) / 3;
}

/***********************************************************
 * Get the correct image for color in landmark maps
 * @param {*} groupIcon
 * @param {*} landmarkColor
 * @returns return the url for image
 ***********************************************************/
 export const getIconGroupWithAnotherColor = (groupIcon, landmarkColor) => {
    if(groupIcon && landmarkColor){
        //Split the image url by / : icons/maps/airline_stops/
        const splitNameIcon = groupIcon.split('/')
        let nameImage = ''

        if(splitNameIcon.length <= 0) return groupIcon;

        //get the name of image before color for example: icons/maps/airline_stops/
        for (let i = 0; i < splitNameIcon.length - 1; i++) {
            nameImage = nameImage + splitNameIcon[i] + '/';
        }
        //add the color and extensión: final result is icons/maps/airline_stops/6B778C.png
        nameImage = nameImage + findColor(landmarkColor) + '.png';
        return nameImage;
    }
    return groupIcon
}

//IMPORTANT!!! google maps renders circle based on meters
//Need to convert feet radius to meters, (In database the radius is saved in Feet)
//Only necesary for landmarks
export const radiusFeetToMeters = (radiusInFeet) => {
    let metersValue = 0
    if(radiusInFeet) {
        metersValue = (radiusInFeet / 3.2808)
    }
    return metersValue
}

/**
 * Return the default color for Landmark tags
 * @param {Tags elements selected} arrayItems
 * @param {items selected into the array} countItemsSelected
 * @param {default color when array selected is clear} defaultColor
 */
export const firstColorFlagTags = (arrayItems, defaultColor, selectedColor = false) => {

    if(selectedColor) return defaultColor;

    if(arrayItems && arrayItems.length == 1){
        return findColor(arrayItems[0]?.color.replace('#', ''))
    }

    return defaultColor;
}


/***********************************************************
 * Functions for initializate maps
***********************************************************/

/*********************************************************
* Show landmarks markers on map
*********************************************************/
export const showLandmarksOnMap = (mapRef,loadObjectsLandmarksOnMap,mapSettingsPreferences,defaultSlideValue) => {
    const landmark = mapSettingsPreferences['landmarkShow'] || false
    const zoomMarker = mapSettingsPreferences['zoomLandmarkMarkersVisible'] ? mapSettingsPreferences['zoomLandmarkMarkersVisible'] : defaultSlideValue;
    const zoomArea = mapSettingsPreferences['zoomLandmarkRadiusVisibleZoom'] ? mapSettingsPreferences['zoomLandmarkRadiusVisibleZoom'] : defaultSlideValue;
    mapRef.current.addMapObjectSettings(landmark, zoomMarker, zoomArea, 'landmarkSettings', loadObjectsLandmarksOnMap)
}

/*********************************************************
* Show Geofences on map
*********************************************************/
export const showGeofencesOnMap = (mapSettingsPreferences,defaultSlideValue,mapRef,loadObjectsGeofenceOnMap) => {
    const landmark = mapSettingsPreferences['geofenceShow'] || false
    const zoomArea = mapSettingsPreferences['zoomGeofenceVisible'] ? mapSettingsPreferences['zoomGeofenceVisible'] : defaultSlideValue;
    mapRef.current.addMapObjectSettings(landmark, zoomArea, 0, 'geofenceSettings', loadObjectsGeofenceOnMap)
}

/*********************************************************
* Add the settings Prevent Overlap Labels on map
*********************************************************/
export const showPreventOverlapLabels = (mapSettingsPreferences,mapRef) => {
    const preventOverlapLabels = mapSettingsPreferences['unitLabelShowOverlap'] || false
    mapRef.current.addMapObjectSettings(preventOverlapLabels, 0, 0, 'noOverlapSettings', null);
}

/*********************************************************
* Add the settings Unit Labels on map
*********************************************************/
export const showUnitLabels = (mapSettingsPreferences,mapRef) => {
    const unitLabelsSettings = mapSettingsPreferences['unitLabelShow'] || false
    //new preferece to show driver name
    const unitLabelSelect = mapSettingsPreferences['unitLabelSelect'] || false

    //reset no overlat settings
    mapRef.current.addMapObjectSettings(false, 0, 0, 'noOverlapSettings', null);

    mapRef.current.addMapObjectSettings(unitLabelsSettings, 0, 0, 'unitLabelSettings', null, null, unitLabelSelect);
}

/*********************************************************
* Show or hide unit clusters
*********************************************************/
export const showUnitCluster = (mapSettingsPreferences,mapRef) => {
    const unitCluster = mapSettingsPreferences['unitCluster']
    const showLabel = mapSettingsPreferences['unitLabelShow']
    if (mapRef) {
        if (!showLabel) {
            mapRef.current.removeMapClusterListener()
        }
        mapRef?.current?.showMarkerCluster(unitCluster, false, showLabel)
    }
    mapRef.current.addMapObjectSettings(unitCluster, 0, 0, 'unitClusterSettings', null);
}

export const convertStringIdsToArray = (ids) => {
    if (ids) return ids.split(',');
    return []
};

export const settingsDesignPolygon = (mapRef, visible = true, color = '#8677D9', strokeColor = '#8677D9') => {
    //define default value for the colors
    if(mapRef){
        mapRef.current.addMapObjectSettings(visible, 0, 0, 'mapCreateObjectSettings', null, { color, strokeColor });
    }
}

/*********************************************************
* Get the flag icons or custom from aws.
*********************************************************/
export const getIconLandmark = (landmark, tags) => {
    const pathFile = `https://s3.amazonaws.com/${endpoints.REPOSITORY_CODE}`;

    if(!tags){
        const landmarkUntagged = styles.color_untagged?.replace("#", "");
        return { color: landmarkUntagged, icon: `${pathFile}/kmls/flagicon/${landmarkUntagged}.png` };
    }

    const landmarkTag = tags.find((tag) => convertStringIdsToArray(landmark?.tagsId).includes(tag.id.toString()))
    let landmarkColor = landmark.color ? landmark.color : landmarkTag?.color || ''
    let landmarkIcon = landmarkTag && landmarkTag.iconName ? landmarkTag.iconName : '' //get icon from landmark group
    landmarkIcon = landmark.iconName ? landmark.iconName : getIconGroupWithAnotherColor(landmarkIcon, landmark.color)// get icon from landmark

    if (!landmarkIcon) {
        landmarkColor = findColor(landmarkColor.replace("#", ""));
        landmarkIcon = `${pathFile}/kmls/flagicon/${landmarkColor}.png`
    } else {
        landmarkIcon = `${pathFile}/${landmarkIcon}`
    }

    return { color: landmarkColor, icon: landmarkIcon };
}

/*********************************************************
* Svg cluster for units (Temporal)
*********************************************************/
export const clusterSvgString = (color = '#1aa0da', size = 30) => {
    return `
        <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 60 60">
            <title>map_cluster</title>
            <g class="map-cluster"><circle cx="30" cy="30" r="19.06" class="cluster-center" fill="${color}" opacity=".8"/>
                <path fill="${color}" opacity=".65" class="cluster-inner-ring" d="M30 9.5A20.5 20.5 0 1 1 9.5 30 20.5 20.5 0 0 1 30 9.5m0-2A22.5 22.5 0 1 0 52.5 30 22.53 22.53 0 0 0 30 7.5z"/>
                <path fill="${color}" opacity=".65" class="cluster-inner-ring-2" data-name="cluster-inner-ring" d="M30 12.63A17.37 17.37 0 1 1 12.63 30 17.37 17.37 0 0 1 30 12.63m0-1.69A19.06 19.06 0 1 0 49.06 30 19.08 19.08 0 0 0 30 10.94z" />
                <path fill="${color}" class="cluster-outer-ring" d="M28.68 56.92a27 27 0 0 1-25.6-25.53h3.1a23.86 23.86 0 0 0 22.5 22.43zm25.14-25.53a23.86 23.86 0 0 1-22.5 22.43v3.1a27 27 0 0 0 25.6-25.53zM28.68 6.18A23.86 23.86 0 0 0 6.17 28.76H3.08a27 27 0 0 1 25.6-25.68zm2.63-3.1v3.1a23.86 23.86 0 0 1 22.52 22.58h3.1A27 27 0 0 0 31.32 3.08z" />
            </g>
        </svg>
    `
}

/********************************************************
 * Svg icon marker for routes
 ********************************************************/
export const IconMarkerRoutePoint = (props) => {
    const number = props?.number || '1'
    return (
      <svg className="routeIcon" xmlns="http://www.w3.org/2000/svg"
        //transform={`rotate(${props.heading})`}
        width="32" height="32">
        <circle cx="16" cy="16" r="12" fill="blue" />
        <text x="50%" y="50%" textAnchor="middle" fill="white" fontSize="12" dy=".3em">{number}</text>
      </svg>
    )
}

export const IconStringMarkerRoutePoint = (color = '#f50057', number = 0, textColor = "white") => {
    //paint border at the objects use: stroke="blue" stroke-width="2"

    return `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="48" viewBox="0 0 32 48">
        <path d="M16 0C7.164 0 0 7.164 0 16c0 14.592 16 32 16 32s16-17.408 16-32C32 7.164 24.836 0 16 0zm0 22c-2.208 0-4-1.792-4-4s1.792-4 4-4s4 1.792 4 4s-1.792 4-4 4z" fill="${color}"/>
        <circle cx="16" cy="20" r="20" fill="${color}" />
        <text x="16" y="18" text-anchor="middle" fill="${textColor}" font-size="18" font-weight="bold" font-family="Arial, sans-serif" dy=".4em">${number > 0 ? number : ''}</text>
        </svg>
    `;
}

/*********************************************************
* Svg marker to create polygons, get the color define
to the parameter
*********************************************************/
export const polygonMarkerPointSvg = (color = '#777777', size = 18) => {
    return `
        <svg xmlns="http://www.w3.org/2000/svg" width='${size}' height='${size}' viewBox="0 0 60 60">
            <title>Shape EndPoint</title>
            <g className="map-shape-endpoint">
                <rect x="4.52" y="4.57" width="50.92" height="50.92" rx="8.5" ry="8.5" fill='${color}' opacity=".15"/>
                <path d="M46.93 6.07a7 7 0 0 1 7 7V47a7 7 0 0 1-7 7H13a7 7 0 0 1-7-7V13.07a7 7 0 0 1 7-7h33.93m0-3H13a10 10 0 0 0-10 10V47a10 10 0 0 0 10 10h33.93a10 10 0 0 0 10-10V13.07a10 10 0 0 0-10-10z" fill='${color}'/>
                <path fill='${color}' d="M24.72 24.78h10.5v10.5h-10.5z"/>
            </g>
        </svg>
    `
}

/*********************************************************
* Convert the seconds value in days, hours and mins
*********************************************************/
export const convertSecondsToTime = (seconds) => {
    if(seconds <=0) {
        return {
            hour: 0,
            min: 0,
            sec: 0
        }
    }

    let hour, min, sec, days;
    days = (seconds / 3600) / 24;
    hour = (seconds - (parseInt(days, 10) * 3600 * 24)) / 3600;
    min =  (seconds - (parseInt(days, 10) * 3600 * 24) - (parseInt(hour, 10) * 3600)) / 60;
    sec =   seconds - ((parseInt(days, 10) * 3600 * 24) + (parseInt(hour, 10) * 3600) + (parseInt(min, 10) * 60));

    //increase minutes
    min = sec >= 30 ? min + 1 : min
    //increase value hours with format days
    hour = parseInt(days, 10) > 0 && min >= 30 ? hour + 1 : hour

    //min value 1 minute
    if(parseInt(days, 10) == 0 && parseInt(hour, 10) == 0 && parseInt(min, 10) == 0){
        min = 1
    }

    return {
        days: parseInt(days, 10) || 0,
        hour: parseInt(hour, 10) || 0,
        min:  parseInt(days, 10) == 0 ? parseInt(min, 10) || 0 : 0
    }
}




const checkBounds = (geoLocation) => {
    const MIN_LAT = degreesToRadians(-90);   // -PI/2
    const MAX_LAT = degreesToRadians(90);    //  PI/2
    const MIN_LON = degreesToRadians(-180);  // -PI
    const MAX_LON = degreesToRadians(180);   //  PI
    if (geoLocation.radLat < MIN_LAT || geoLocation.radLat > MAX_LAT ||
        geoLocation.radLon < MIN_LON || geoLocation.radLon > MAX_LON){
            console.log("Invalid Argument");
            return false;
        }
    return true;
}

const radiansToDegrees = (radians) => {
    let pi = Math.PI;
    return radians * (180/pi);
}

const degreesToRadians = (degrees) => {
    let pi = Math.PI;
    return degrees * (pi/180);
}

const fromDegrees = (latitude, longitude) => {
    let geoLocation = {
        radLat : degreesToRadians(latitude),
        radLon : degreesToRadians(longitude),
        degLat : latitude,
        degLon : longitude
    }
    const validation = checkBounds(geoLocation);
    if(validation)
        return geoLocation;
    return validation;
}

const fromRadians = (latitude, longitude) => {
    let geoLocation = {
        radLat : latitude,
        radLon : longitude,
        degLat : radiansToDegrees(latitude),
        degLon : radiansToDegrees(longitude)
    }
    const validation = checkBounds(geoLocation);
    if(validation)
        return geoLocation;
    return validation;
}

export const getEarthsRadius = (unit_of_measurement) => {
    const EARTHS_RADIUS_MI = 3958.762079;
    const EARTHS_RADIUS_KM = 6371.01;
    let u = unit_of_measurement;
    if(u == 'miles' || u == 'mi')
        return EARTHS_RADIUS_MI;
    else if(u == 'kilometers' || u == 'km')
        return EARTHS_RADIUS_KM;

    return 0;
}

export const boundingCoordinates = (distance, unit_of_measurement, geoLocation) => {

    const MIN_LAT = degreesToRadians(-90);   // -PI/2
    const MAX_LAT = degreesToRadians(90);    //  PI/2
    const MIN_LON = degreesToRadians(-180);  // -PI
    const MAX_LON = degreesToRadians(180);   //  PI

    let radius = getEarthsRadius(unit_of_measurement);
    if (radius < 0 || distance < 0) {
        console.log('Arguments must be greater than 0.', new Date())
        return false;
    }

    // angular distance in radians on a great circle
    let angular = distance / radius;
    let minLat = geoLocation.radLat - angular;
    let maxLat = geoLocation.radLat + angular;
    let minLon = 0;
    let maxLon = 0;
    if (minLat > MIN_LAT && maxLat < MAX_LAT) {
        const deltaLon = Math.asin(Math.sin(angular) / Math.cos(geoLocation.radLat));
        minLon = geoLocation.radLon - deltaLon;

        if (minLon < MIN_LON) minLon += 2 * Math.PI;

        maxLon = geoLocation.radLon + deltaLon;

        if (maxLon > MAX_LON) maxLon -= 2 * Math.PI;
    } else {
        // a pole is within the distance
        minLat = Math.max(minLat, MIN_LAT);
        maxLat = Math.max(maxLat, MAX_LAT);
        minLon = MIN_LON;
        maxLon = MAX_LON;
    }
    let arrayReturn = [];
    arrayReturn.push(fromRadians(minLat, minLon))
    arrayReturn.push(fromRadians(maxLat, maxLon))
    return arrayReturn;
}

export const createSquareBoundingboxByMilesDistance = (latitude, longitude, radiusInMetter) => {
    let geoLocation = fromDegrees(latitude, longitude);
    let radiusToFeet = radiusInMetter * 3.281; //convert metters to feet
    let radiusMiles = radiusToFeet * 0.00018939393;
    let coordinates = boundingCoordinates(radiusMiles, 'miles', geoLocation);
    const response = []
    if(coordinates && coordinates.length > 0){
        response.push({ latitude: coordinates[1].degLat, longitude: coordinates[1].degLon })
        response.push({ latitude: coordinates[0].degLat, longitude: coordinates[1].degLon })
        response.push({ latitude: coordinates[0].degLat, longitude: coordinates[0].degLon })
        response.push({ latitude: coordinates[1].degLat, longitude: coordinates[0].degLon })
        response.push({ latitude: coordinates[1].degLat, longitude: coordinates[1].degLon })
    }
    return response
}

/******************************************************
 * This function takes in latitude and longitude of two location
 * and returns the distance between them as the crow flies (in km)
 * @param {float} lat1
 * @param {float} lon1
 * @param {float} lat2
 * @param {float} lon2
 * @returns Return the distance of the points in metters
 ******************************************************/
export function calcDistanceToPoints(lat1, lon1, lat2, lon2) {
    const earthRadius = 6371000; // Radius of the Earth in meters
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius * c;
    return distance; //return distance on meters
  }

export function toRadians(degrees) {
        return degrees * (Math.PI / 180);
}

export function calculateDistanceTraveled(speedKmH, timeSeconds) {
    // Convert speed from km/h to km/s
    const speedKmS = speedKmH / 3600;

    // Calculate distance traveled in kilometers
    const distanceKm = speedKmS * timeSeconds;

    // Convert distance to meters
    const distanceMeters = distanceKm * 1000;

    return distanceMeters; // Returns the distance in meters
}

/******************************************************
 * Converts numeric degrees to radians
******************************************************/
export const toRad = (Value) => {
  return Value * Math.PI / 180;
}

/*******************************************************
 * Return the latitude or longitud point depends on
 * the distance on metters
 * @param {float} latitude lat or lng position
 * @param {float} meters distance to calculate
 * @returns return the Latitude or Longitude
 ******************************************************/
export const getLatByDistance = (latitude, your_meters) => {
    let earth = 6378.137,  //radius of the earth in kilometer
    pi = Math.PI,
    m = (1 / ((2 * pi / 360) * earth)) / 1000;  //1 meter in degree

    let new_latitude = latitude + (your_meters * m);
    return new_latitude;
}

/*******************************************************
 * Return the latitude or longitud point depends on
 * the distance on metters related to square object
 * @param {float} latitude lat position
 * @param {float} longitude lng position
 * @param {float} meters distance to calculate in metters
 * @returns return the longitude
 ******************************************************/
export const getLngByDistance = (latitude, longitude, your_meters) => {
    let earth = 6378.137,  //radius of the earth in kilometer
    pi = Math.PI,
    cos = Math.cos,
    m = (1 / ((2 * pi / 360) * earth)) / 1000;  //1 meter in degree

    let new_longitude = longitude + (your_meters * m) / cos(latitude * (pi / 180));
    return new_longitude;
}



export const getMainTag = (item, tagsGroups, isLandmark = true) =>{
    let group = null, startGroup = null;

    if(!isLandmark){
        //get first group
        const groupsIds = tagsGroups.map((item) => parseInt(item.id))
        const idMinGroup = Math.min(...groupsIds)
        startGroup = tagsGroups.find((item) => item.id == idMinGroup)
    }

    if (tagsGroups) {
        let valid = item?.tagsId
        if (valid) {
        const tagsArray = item.tagsId.split(',')
        group = tagsGroups.find((element) => tagsArray.includes(element.id.toString()));
        }

        //this validation is only for landmarks
        if (valid && !group && isLandmark) return null; // no have permision

        if (!isLandmark && !group) {
            group = startGroup
        }
    }
    return group;
}

/*******************************************************
* Return the lat lng value from the data coming object
* @param {JSON} item
*******************************************************/
export const validateLatLng = (item, valNumeric = false) => {
    let lat = '', lng = '';
    if (item['latitude']) {
      lat = item['latitude'].toString();
    }

    if (item['lat'] && lat == '') {
      lat = item['lat'].toString();
    }

    if (item['longitude']) {
      lng = item['longitude'].toString();
    }

    if (item['lng'] && lng == '') {
      lng = item['lng'].toString();
    }

    if (item['lon'] && lng == '') {
      lng = item['lon'].toString();
    }

    if(item['center_latlong']){
        let splitValue = item['center_latlong'].split(',')
        if(splitValue && splitValue.length > 1){
          if(splitValue[0] != 'undefined' && splitValue[1] != 'undefined'){
            lat = splitValue[0]
            lng = splitValue[1]
          }
        }
    }

    if (valNumeric && lat && lng) {
      lat = parseFloat(lat);
      lng = parseFloat(lng);
    }

    return { lat: lat, lng: lng };
}

export const letterMarkersGoogleRoute = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

/*******************************************************
   * Get the positions at the marker
*******************************************************/
export const getRouteCoordinatesFromDirectionService = (response) => {
    if (!response) return [];
    // get the coordinates of the route
    var route = response.routes[0];
    var routeCoordinates = [];
    for (var i = 0; i < route.legs.length; i++) {
      var leg = route.legs[i];
      for (var j = 0; j < leg.steps.length; j++) {
        var step = leg.steps[j];
        for (var k = 0; k < step.path.length; k++) {
          var path = step.path[k];
          routeCoordinates.push(path);
        }
      }
    }
    return routeCoordinates
  }

export const createIconMarkerForRoute = (mapObject) => {
    let stringToRoutePoint = '';

    //All points is Stop
    if(mapObject?.eventName == 'Stop'){ //mapObject.value == number
        stringToRoutePoint = IconStringMarkerRoutePoint("#f50057", mapObject?.value + 1 || 1); //increase the number because start in 1
    }else if(mapObject?.eventName == 'Waypoint'){ 
        //waypoint no have number
        stringToRoutePoint = IconStringMarkerRoutePoint("#ff6623", 0);
    }
    
    let iconMarker = {
        // Convierte SVG to URL
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(stringToRoutePoint),
        scaledSize: new google.maps.Size(32, 32), // size of the icon
    };
    return iconMarker
}

export const createIconMarkerForRouteTracker = (mapObject) => {
    let stringToRoutePoint = '';

    const objectToRouteColor = ColorsToRoutePointsOnRoutesTracker.find((item) => item.name == mapObject.eventName);

    switch(mapObject?.eventName){
        case "Pending":
            stringToRoutePoint = IconStringMarkerRoutePoint(objectToRouteColor?.color, mapObject?.value + 1 || 1, "black"); //increase the number because start in 1
            break;

        case "InRoute":
            stringToRoutePoint = IconStringMarkerRoutePoint(objectToRouteColor?.color, mapObject?.value + 1 || 1); //increase the number because start in 1
            break;

        case "OnSite":
            stringToRoutePoint = IconStringMarkerRoutePoint(objectToRouteColor?.color, mapObject?.value + 1 || 1); //increase the number because start in 1
            break;

        case "Done":
            stringToRoutePoint = IconStringMarkerRoutePoint(objectToRouteColor?.color, mapObject?.value + 1 || 1); //increase the number because start in 1
            break;

        case "DoneWithException":
            stringToRoutePoint = IconStringMarkerRoutePoint(objectToRouteColor?.color, mapObject?.value + 1 || 1); //increase the number because start in 1
            break;

        default:
            //pending state
            stringToRoutePoint = IconStringMarkerRoutePoint(objectToRouteColor?.color || '#f0f0f0', mapObject?.value + 1 || 1, "black"); //increase the number because start in 1
    }

    let iconMarker = {
        // Convierte SVG to URL
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(stringToRoutePoint),
        scaledSize: new google.maps.Size(32, 32), // size of the icon
    };
    return iconMarker
}

export const returnOptimizeRoutePoints = (response, callback) => {
    const waypointOrder = response.routes[0].waypoint_order;
    callback && callback(waypointOrder);
}

//comes the unitTime in miliseconds
export const validateTrailTimeMinsCompare = (unitTime1, unitTime2, mins = 2) => {

    if (unitTime1 < 1000000000000) {
        // If both timestamps are greater than 1000000000000, then assume they are in milliseconds
        unitTime1 = unitTime1 * 1000;
    }

    if (unitTime2 < 1000000000000) {
        // If both timestamps are greater than 1000000000000, then assume they are in milliseconds
        unitTime2 = unitTime2 * 1000;
    }

	const diff = unitTime2 - unitTime1 ;

	// Convert in miliseconds
	const oneInMiliseconds = mins * 60 * 1000;

	// validate diff with time in mins.
	if (diff > oneInMiliseconds) {
    	return false;
	}
	return true;
}

//comes the unitTime in miliseconds
export const validateTrailTimeMins = (unitTime, mins = 2) => {

    let currentTime = Date.now();
    if (unitTime < 1000000000000) {
        // If both timestamps are greater than 1000000000000, then assume they are in milliseconds
        unitTime = unitTime * 1000;
    }
	const diff = currentTime - unitTime ;

	// Convert in miliseconds
	const oneInMiliseconds = mins * 60 * 1000;

	// validate diff with time in mins.
	if (diff > oneInMiliseconds) {
    	return false;
	}
	return true;
}

export const convertDateToSeconds = (timestamp) =>{
    let value = 0;
    try{
      value = parseInt(timestamp)
      if (value > 1000000000000) {
        // If both timestamps are greater than 1000000000000, then assume they are in milliseconds
        value = Math.floor(timestamp / 1000);
      }
    }catch(ex){
      console.log('error to convert convertDateToSeconds', new Date())
    }
    return value;
}

export const validateDirectionChange = (currentDirection, previousDirection) => {
    // Calculate the absolute angular difference between the directions
    let difference = Math.abs(currentDirection - previousDirection);

    // Adjust the difference if it's greater than 180 degrees
    if (difference > 180) {
        difference = 360 - difference;
    }

    // Check if the difference is greater or equal than 45 degrees
    if (difference >= 45) {
        return true; // The direction has changed more than 45 degrees in any direction
    } else {
        return false; // The direction hasn't changed enough
    }
}

export const eventsWithoutSpeed = [
    'Ignition Off',
    'Ignition On',
    'Travel Start',
    'Motion Start',
    'Idle',
    'Travel Stop',
]


export const orderTrailPolilyne = (trails = []) => {

    if(trails?.length === 0) return
    let trailRoute = [];
    let dataTrails = [...trails];

    dataTrails = dataTrails.sort((a, b) => {
      // Convertir to int
      const unitTimeA = parseInt(getApiDate(a.unitTime));
      const unitTimeB = parseInt(getApiDate(b.unitTime));

      // sort
      return unitTimeA - unitTimeB;
    });

    let newDataTrailsArray = [...dataTrails]

    let haveTimestamp = true;
    let previousTimestamp = null; // To track the timestamp of the previous main event
    
    // Process all trails
    newDataTrailsArray.map((item) => {
        let color = getEventColor(item?.eventName);
        if (Array.isArray(item.trail) && item.trail.length > 0) {
            // Sort trail elements
            let detailsTrailsElements = [...item.trail];
            if (item.trail[0].timestamp > 0) {
                detailsTrailsElements = detailsTrailsElements.sort((a, b) => {
                    const unitTimeA = parseInt(a.timestamp);
                    const unitTimeB = parseInt(b.timestamp);
                    // Sort by timestamp
                    return unitTimeA - unitTimeB;
                });
            } else {
                // If no timestamp is available
                haveTimestamp = false;
                let reversedArray = [];
                for (let i = detailsTrailsElements.length - 1; i >= 0; i--) {
                    reversedArray.push(detailsTrailsElements[i]);
                }
                detailsTrailsElements = reversedArray;
            }
    
            // Validate and add trail events
            detailsTrailsElements.forEach((trail) => {
                const trailTimestamp = convertDateToSeconds(trail.timestamp);
    
                // Validate that the trail timestamp is within the valid range
                if (
                    (!previousTimestamp || trailTimestamp >= previousTimestamp) && // Not earlier than the previous main event
                    trailTimestamp <= convertDateToSeconds(parseInt(getApiDate(item.unitTime))) // Not later than the current main event
                ) {
                    trailRoute.push({
                        ...trail,
                        lng: trail.lon,
                        color: color,
                        eventName: item.eventName,
                        timestamp: trailTimestamp,
                        mainId: item?.id,
                        isTrail: true
                    });
                }
            });
        }
    
        // Add the main event to the list
        const currentTimestamp = convertDateToSeconds(parseInt(getApiDate(item.unitTime)));
        trailRoute.push({
            timestamp: currentTimestamp,
            lat: item.latitude,
            lng: item.longitude,
            lon: item.longitude,
            color: color,
            eventName: item.eventName,
            mainId: item?.id
        });
    
        // Update the previous main event timestamp
        previousTimestamp = currentTimestamp;
    });

    //order the trailRoute elements
    if(haveTimestamp){
      trailRoute = trailRoute.sort((a, b) => {
        // Convertir to int
        const unitTimeA = parseInt(a.timestamp);
        const unitTimeB = parseInt(b.timestamp);

        // sort
        return unitTimeA - unitTimeB;
      });
    }

    let cutTrailLine = false;
    //validate distance
    trailRoute = trailRoute?.map((item, indexTrail) => {
        if(cutTrailLine){
            cutTrailLine = false;
            item.cutTrailLine = true;
            LogManagerConsole("VehicleTrails", 'Error to trails data (speed validation)', 'Value Vehicle:', item)
        }
        if(indexTrail + 1 < trailRoute.length - 1){
            //1. find the next event to compare
            const itemToEval = trailRoute[indexTrail + 1];
    
            //2. get diferente on time
            const diferencesInSecondsLast = Math.abs(item.timestamp - itemToEval.timestamp);

            //3. make a calc to diferente between time and traveled distance
            //the errors in SGSD-6840 increase the max value for units in 140 per 350
            const maxDistanceTraveledLast = diferencesInSecondsLast > 6 ? calculateDistanceTraveled(350, diferencesInSecondsLast) : 1000; //500 metters to 120 km per hour for speed units (every 30 seconds to come data)
    
            //if speed is mayor o equal to 120km per hour for TRUCKS
            //4. value of distance is in Metters
            const distanceValidationInMettersLast = calcDistanceToPoints(item?.lat, item?.lng, itemToEval?.lat, itemToEval?.lng);

            const isValidCoordinate = validateCoordinates(item?.lat, item?.lng) && validateCoordinates(itemToEval?.lat, itemToEval?.lng);
            
            if ((distanceValidationInMettersLast > maxDistanceTraveledLast && (item?.timestamp && itemToEval?.timestamp)) // Validate distance based on time difference between points
                || (!diferencesInSecondsLast && distanceValidationInMettersLast > 10000) // If there's no significant time difference and the distance is over 10km, the data might be inconsistent
                || !isValidCoordinate) { // Invalid latitude or longitude coordinates
                cutTrailLine = true;
            }
        }
        return item;
    })

    return trailRoute
  
}

/* ----------------------------------------------------------------------------------------
 * It's necessary to remove the waypoints from the count of elements 
   and count only the waypoints, because in the interface only the stops will have numbers.
 * @param {Object} data - The data object containing route information.
 * @returns {Object} all Object with the new routePoints only count stops in variable counterStop
 ------------------------------------------------------------------------------------------ */
export const routeWaypointsWithoutNumbers = (data) => {
    let routePoints = data.points?.length > 0 ? [...data.points] : [];
    let counterStop = -1;
    routePoints = routePoints.map((point) => {
        //if typePoint is Stop add the counter
        counterStop = point.typePoint == "Stop" ? counterStop + 1 : counterStop;
        return {
            ...point,
            counterStop : counterStop,
            value: counterStop //this attibute paint the number on map marker
        };
    });
    return { ...data, points: routePoints}; 
}

export const validateCoordinates = (latitude, longitude) => {
    // Convert the input values to numbers to ensure they are numeric
    const lat = parseFloat(latitude);
    const lng = parseFloat(longitude);
  
    // Check if the values are numbers, within the valid ranges, and different from zero
    return !isNaN(lat) && 
           !isNaN(lng) &&
           lat >= -90 && lat <= 90 &&
           lng >= -180 && lng <= 180 &&
           lat !== 0 &&
           lng !== 0;
  }

export const drawLandmarkOnMap = (item, mapRef, hideMarker = false) => {

  if(!mapRef && !item) return;

  const coordinates = new google.maps.LatLng(item.latitude, item.longitude); // eslint-disable-line no-undef
  const radius = item.shape == "circle" ? item.radius : 0
  const coordinatesCenter = radius > 0 ? [{ lat: item.latitude, lng: item.longitude }] : item.coordinates
  mapRef.current.centerByFitBounds(coordinatesCenter, radius)
  const mapObject = {
    id: item?.id,
    position: coordinates,
    label: item?.name,
    icon: {
      rotation: 0
    },
    layerName: TypeLayer.Landmark
  }
  mapRef.current.modalPopupEvent(mapObject, mapObject);

  //Always show the landmark on map
  mapRef.current.drawLandmark({ ...item, hideMarker: hideMarker, color: `#${item?.color || '8677D9'}`, url: item.iconName}, radiusFeetToMeters(radius), coordinatesCenter, true)

}

export const getDateFromReactCalendarToUtc = (paramDate, timeZoneUser) => {
    const fechaSinTimezone = moment(paramDate).format('YYYY-MM-DD HH:mm:ss');
    const fechaConTimezone = moment.tz(fechaSinTimezone, 'YYYY-MM-DD HH:mm:ss', timeZoneUser);
    const utcDate = fechaConTimezone.utc();
    const formattedDateInUTC = utcDate.toISOString();
    return formattedDateInUTC;
}

export const validateEventColor = (item) => {
    let eventName = '';
    if (item && item['eventName']) {
      eventName = item['eventName'].toString();
    }

    if (item && item['event'] && eventName == '') {
      eventName = item['event'].toString();
    }

    return getEventColor(eventName);
}

//functions to create envelope for the landmarks and polygons

/********************************************************
 * Creates a bounding box (envelope) for a circle object.
 * The circle object should be an instance of google.maps.Circle.
 * The bounding box is calculated based on the circle's center and radius.
 * @param {*} circleObject 
 * @returns {Object} An object containing the bounding box coordinates, center, and radius of the circle.
 * @returns {boolean} Returns false if the provided object is not a valid circle.
 * @example
 * const circle = new google.maps.Circle({
 *   envelop: { north: 37.7749, south: 37.7749, east: -122.4194, west: -122.4194 },
 *   center: { lat: 37.7749, lng: -122.4194 },
 *   radius: 1000 // in meters
 * });
 ********************************************************/
export const createCircleEnvelop = (circleObject) => {
    if (!(circleObject instanceof google.maps.Circle)) {
        //console.error("The provided object is not a valid circle.");
        return false;
    }

    const center = circleObject.getCenter();
    const radius = circleObject.getRadius();

    // Calculate the bounding box of the circle
    const envelop = {
        north: center.lat() + radius / 111320,
        south: center.lat() - radius / 111320,
        east: center.lng() + radius / (111320 * Math.cos(center.lat() * (Math.PI / 180))),
        west: center.lng() - radius / (111320 * Math.cos(center.lat() * (Math.PI / 180))),
    };

    return {
        envelop,
        center,
        radius
    }
}; 


/********************************************************
 * Creates a bounding box (envelope) for a polygon object.
 * The polygon object should be an instance of google.maps.Polygon.
 * The bounding box is calculated based on the vertices of the polygon.
 * @returns {Object} An object containing the bounding box coordinates of the polygon.  
 * @param {*} polygonObject 
 * @returns {boolean} Returns false if the provided object is not a valid polygon. 
 *********************************************************/
export const createPolygonEnvelop = (polygonObject) => {

    if (!(polygonObject instanceof google.maps.Polygon)) {
      //console.error("The provided object is not a valid polygon.");
      return false;
    }

    const path = polygonObject.getPath();

    // Calculate the bounding box of the polygon
    let minLat = Number.POSITIVE_INFINITY;
    let maxLat = Number.NEGATIVE_INFINITY;
    let minLng = Number.POSITIVE_INFINITY;
    let maxLng = Number.NEGATIVE_INFINITY;

    for (let i = 0; i < path.getLength(); i++) {
      const vertex = path.getAt(i);
      minLat = Math.min(minLat, vertex.lat());
      maxLat = Math.max(maxLat, vertex.lat());
      minLng = Math.min(minLng, vertex.lng());
      maxLng = Math.max(maxLng, vertex.lng());
    }

    // Create the bounding box of the polygon
    const envelop = {
      north: maxLat,
      south: minLat,
      east: maxLng,
      west: minLng,
    };

    return {
      envelop
    };
};